/** The captures include the cabinet. Do not add another cabinet by default. */
export const AMP_MODELS = Object.freeze([
  { id: 'guitar-clean', name: 'Guitar · Clean', file: 'clean.nam', family: 'guitar', trimDb: 0, description: 'Open, responsive clean amp and cabinet' },
  { id: 'guitar-drive', name: 'Guitar · Driven', file: 'distorted.nam', family: 'guitar', trimDb: -10, description: 'Saturated guitar amp and cabinet' },
  { id: 'bass-clean', name: 'Bass · Clean', file: 'bass-clean.nam', family: 'bass', trimDb: -8, description: 'Full-bodied bass amp and cabinet' },
  { id: 'bass-drive', name: 'Bass · Driven', file: 'bass-distorted.nam', family: 'bass', trimDb: -10, description: 'Driven bass amp and cabinet' }
]);

export const AMP_DEFAULTS = Object.freeze({ model: 'guitar-clean', inputDb: 0, bass: 0, mid: 0, treble: 0, outputDb: 0, mix: 1 });
export const AMP_RANGES = Object.freeze({ inputDb: [-24, 18], bass: [-12, 12], mid: [-12, 12], treble: [-12, 12], outputDb: [-24, 12], mix: [0, 1] });
export const ampModel = id => AMP_MODELS.find(model => model.id === id);
export function normalizeAmpParams(params = {}) {
  if (!ampModel(params.model ?? AMP_DEFAULTS.model)) throw new Error('Unknown amp model. Choose guitar-clean, guitar-drive, bass-clean or bass-drive.');
  const result = { ...AMP_DEFAULTS, model: params.model ?? AMP_DEFAULTS.model };
  Object.entries(AMP_RANGES).forEach(([key, [min, max]]) => {
    const value = params[key] ?? AMP_DEFAULTS[key];
    result[key] = Number.isFinite(value) ? Math.max(min, Math.min(max, value)) : AMP_DEFAULTS[key];
  });
  return result;
}
